import { createSlice } from "@reduxjs/toolkit";

// Define initial state for the slice.
const initialState = { data: [], error: null, loading: false, ip: null };

//  Define slice and it's reducer functions.
const monitorReceiptsSlice = createSlice({
  name: "monitorReceiptsSlice",
  initialState,
  reducers: {
    setData(state, action) {
      state.data = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setIP(state, action) {
      state.ip = action.payload;
    },
    resetState(state) {
      state.data = [];
      state.error = null;
      state.loading = false;
      state.ip = null;
    },
  },
});

export const monitorReceiptsAction = monitorReceiptsSlice.actions;

export default monitorReceiptsSlice;
